var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCongratulations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 67,
    viewBox: "0 0 252 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7235_20320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1741 29.7585C20.619 32.2212 6.91007 43.782 2 49.2546C6.32086 48.3995 16.0232 46.6893 20.2655 46.6893C24.5078 46.6893 23.2115 48.3995 22.0331 49.2546C20.8547 50.7937 17.7908 55.6164 14.9626 62.5939C28.6322 53.1538 45.7978 48.0574 52.6719 46.6893C51.1007 45.4922 45.6014 40.43 36.1741 29.7585Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.369 29.7585C230.924 32.2212 244.633 43.782 249.543 49.2546C245.222 48.3995 235.52 46.6893 231.278 46.6893C227.035 46.6893 228.331 48.3995 229.51 49.2546C230.688 50.7937 233.752 55.6164 236.58 62.5939C222.911 53.1538 205.745 48.0574 198.871 46.6893C200.442 45.4922 205.942 40.43 215.369 29.7585Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_7235_20320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.2072 44.6339C56.6786 40.5295 54.8324 31.6365 53.8504 27.7031C46.9763 29.7553 32.521 34.578 29.6928 37.4511C26.1576 41.0425 55.618 49.7644 56.2072 44.6339Z",
    fill: "#428B9C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_7235_20320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.336 44.6339C194.864 40.5295 196.711 31.6365 197.693 27.7031C204.567 29.7553 219.022 34.578 221.85 37.4511C225.385 41.0425 195.925 49.7644 195.336 44.6339Z",
    fill: "#428B9C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_7235_20320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1571 40.5312L17.9082 13.3394C33.8168 8.89292 77.0647 0 122.787 0C168.51 0 217.257 8.89292 235.915 13.3394L224.72 38.992C206.848 36.5978 161.439 31.8093 122.787 31.8093C84.1352 31.8093 42.2622 37.6239 26.1571 40.5312Z",
    fill: "#68E1FD"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.8509 24.9821C55.1263 24.9821 52.8198 23.108 52.8198 19.4753C52.8198 15.9002 55.2128 13.8531 57.9374 13.8531C59.3357 13.8531 60.4602 14.5018 61.1954 15.2515L59.8547 16.8949C59.3069 16.4047 58.7447 16.0587 57.9807 16.0587C56.5967 16.0587 55.4579 17.2985 55.4579 19.3888C55.4579 21.5223 56.4382 22.7621 57.9518 22.7621C58.8168 22.7621 59.4943 22.3296 59.9989 21.7818L61.3539 23.3964C60.4457 24.4487 59.2492 24.9821 57.8509 24.9821ZM68.0139 24.9821C65.9236 24.9821 63.9919 23.3964 63.9919 20.6718C63.9919 17.9616 65.9236 16.3759 68.0139 16.3759C70.0898 16.3759 72.0215 17.9616 72.0215 20.6718C72.0215 23.3964 70.0898 24.9821 68.0139 24.9821ZM68.0139 22.9062C68.9653 22.9062 69.3978 22.0413 69.3978 20.6718C69.3978 19.3167 68.9653 18.4518 68.0139 18.4518C67.0481 18.4518 66.6156 19.3167 66.6156 20.6718C66.6156 22.0413 67.0481 22.9062 68.0139 22.9062ZM75.3619 24.7803V16.5777H77.4522L77.6396 17.6012H77.6828C78.3604 16.9381 79.1965 16.3759 80.3065 16.3759C82.0941 16.3759 82.8581 17.6589 82.8581 19.7059V24.7803H80.2921V20.0231C80.2921 18.8842 79.9893 18.5671 79.3406 18.5671C78.764 18.5671 78.418 18.8266 77.9279 19.3023V24.7803H75.3619ZM89.5211 28.2256C87.6326 28.2256 86.0901 27.6346 86.0901 26.1642C86.0901 25.4866 86.4794 24.9388 87.2434 24.5496V24.4775C86.8109 24.1892 86.4938 23.7568 86.4938 23.0648C86.4938 22.4882 86.8686 21.9115 87.4164 21.5367V21.4791C86.8253 21.0754 86.292 20.3114 86.292 19.3455C86.292 17.3562 87.9498 16.3759 89.7229 16.3759C90.1986 16.3759 90.6455 16.448 91.0203 16.5777H94.0332V18.4373H92.7791C92.8944 18.668 92.9953 19.0428 92.9953 19.432C92.9953 21.3493 91.5393 22.1854 89.7229 22.1854C89.449 22.1854 89.1175 22.1422 88.7571 22.0413C88.5841 22.2143 88.4976 22.3296 88.4976 22.6179C88.4976 22.9927 88.8291 23.1657 89.7085 23.1657H91.0059C93.0241 23.1657 94.1774 23.7856 94.1774 25.2704C94.1774 27.0003 92.3754 28.2256 89.5211 28.2256ZM89.7229 20.643C90.3284 20.643 90.7753 20.2105 90.7753 19.3455C90.7753 18.5238 90.3284 18.0914 89.7229 18.0914C89.1319 18.0914 88.685 18.5238 88.685 19.3455C88.685 20.2105 89.1319 20.643 89.7229 20.643ZM89.9247 26.6255C90.9771 26.6255 91.7123 26.2363 91.7123 25.7173C91.7123 25.2272 91.2798 25.1263 90.5158 25.1263H89.7373C89.1463 25.1263 88.8291 25.0974 88.5697 25.0253C88.3102 25.256 88.1948 25.4866 88.1948 25.7605C88.1948 26.3372 88.8868 26.6255 89.9247 26.6255ZM97.1933 24.7803V16.5777H99.2836L99.471 18.0049H99.5143C100.12 16.9093 101.028 16.3759 101.85 16.3759C102.34 16.3759 102.614 16.448 102.844 16.5489L102.426 18.7545C102.124 18.6824 101.878 18.6247 101.518 18.6247C100.913 18.6247 100.177 19.014 99.7593 20.0952V24.7803H97.1933ZM107.109 24.9821C105.595 24.9821 104.673 23.8577 104.673 22.4882C104.673 20.7583 106.028 19.8213 109.228 19.4753C109.17 18.8121 108.824 18.4229 107.988 18.4229C107.34 18.4229 106.662 18.6824 105.84 19.1437L104.947 17.4571C106.028 16.8084 107.195 16.3759 108.478 16.3759C110.597 16.3759 111.794 17.558 111.794 20.124V24.7803H109.704L109.531 23.9586H109.459C108.781 24.564 108.017 24.9821 107.109 24.9821ZM107.988 22.9927C108.507 22.9927 108.853 22.7477 109.228 22.344V21.0322C107.628 21.234 107.109 21.7097 107.109 22.2863C107.109 22.7621 107.455 22.9927 107.988 22.9927ZM118.326 24.9821C116.265 24.9821 115.429 23.6703 115.429 21.7385V18.5815H114.319V16.6786L115.587 16.5777L115.875 14.4009H117.995V16.5777H119.926V18.5815H117.995V21.7097C117.995 22.6179 118.427 22.9783 119.033 22.9783C119.292 22.9783 119.58 22.8918 119.782 22.8197L120.186 24.6794C119.753 24.8091 119.162 24.9821 118.326 24.9821ZM125.726 24.9821C123.924 24.9821 123.16 23.6991 123.16 21.6521V16.5777H125.726V21.3349C125.726 22.4593 126.029 22.7909 126.677 22.7909C127.254 22.7909 127.614 22.5602 128.047 21.9548V16.5777H130.613V24.7803H128.523L128.335 23.6558H128.278C127.6 24.4631 126.836 24.9821 125.726 24.9821ZM136.744 24.9821C134.985 24.9821 134.409 23.8288 134.409 22.1134V13.2621H136.975V22.1999C136.975 22.7477 137.22 22.9062 137.421 22.9062C137.508 22.9062 137.566 22.9062 137.71 22.8774L138.012 24.7659C137.739 24.8812 137.32 24.9821 136.744 24.9821ZM143.001 24.9821C141.487 24.9821 140.564 23.8577 140.564 22.4882C140.564 20.7583 141.92 19.8213 145.12 19.4753C145.062 18.8121 144.716 18.4229 143.88 18.4229C143.231 18.4229 142.554 18.6824 141.732 19.1437L140.838 17.4571C141.92 16.8084 143.087 16.3759 144.37 16.3759C146.489 16.3759 147.686 17.558 147.686 20.124V24.7803H145.596L145.423 23.9586H145.351C144.673 24.564 143.909 24.9821 143.001 24.9821ZM143.88 22.9927C144.399 22.9927 144.745 22.7477 145.12 22.344V21.0322C143.52 21.234 143.001 21.7097 143.001 22.2863C143.001 22.7621 143.347 22.9927 143.88 22.9927ZM154.218 24.9821C152.157 24.9821 151.32 23.6703 151.32 21.7385V18.5815H150.21V16.6786L151.479 16.5777L151.767 14.4009H153.886V16.5777H155.818V18.5815H153.886V21.7097C153.886 22.6179 154.319 22.9783 154.924 22.9783C155.184 22.9783 155.472 22.8918 155.674 22.8197L156.078 24.6794C155.645 24.8091 155.054 24.9821 154.218 24.9821ZM159.138 24.7803V16.5777H161.704V24.7803H159.138ZM160.421 15.4389C159.556 15.4389 158.994 14.9199 158.994 14.1126C158.994 13.3197 159.556 12.8008 160.421 12.8008C161.272 12.8008 161.848 13.3197 161.848 14.1126C161.848 14.9199 161.272 15.4389 160.421 15.4389ZM169.06 24.9821C166.97 24.9821 165.038 23.3964 165.038 20.6718C165.038 17.9616 166.97 16.3759 169.06 16.3759C171.136 16.3759 173.068 17.9616 173.068 20.6718C173.068 23.3964 171.136 24.9821 169.06 24.9821ZM169.06 22.9062C170.012 22.9062 170.444 22.0413 170.444 20.6718C170.444 19.3167 170.012 18.4518 169.06 18.4518C168.095 18.4518 167.662 19.3167 167.662 20.6718C167.662 22.0413 168.095 22.9062 169.06 22.9062ZM176.408 24.7803V16.5777H178.499L178.686 17.6012H178.729C179.407 16.9381 180.243 16.3759 181.353 16.3759C183.141 16.3759 183.905 17.6589 183.905 19.7059V24.7803H181.339V20.0231C181.339 18.8842 181.036 18.5671 180.387 18.5671C179.811 18.5671 179.465 18.8266 178.974 19.3023V24.7803H176.408ZM190.078 24.9821C189.011 24.9821 187.757 24.5208 186.92 23.8288L188.059 22.2287C188.809 22.7909 189.486 23.0936 190.135 23.0936C190.813 23.0936 191.101 22.8486 191.101 22.4449C191.101 21.9548 190.308 21.7241 189.472 21.3926C188.492 21.0033 187.382 20.3402 187.382 18.9707C187.382 17.4282 188.636 16.3759 190.553 16.3759C191.836 16.3759 192.788 16.8949 193.48 17.4282L192.341 18.9563C191.75 18.5382 191.173 18.2644 190.64 18.2644C190.049 18.2644 189.775 18.4662 189.775 18.8554C189.775 19.3455 190.481 19.5329 191.332 19.8357C192.355 20.2249 193.494 20.8159 193.494 22.3008C193.494 23.8144 192.312 24.9821 190.078 24.9821ZM197.7 20.888L197.325 16.0155L197.239 13.7234H199.819L199.733 16.0155L199.358 20.888H197.7ZM198.522 24.9821C197.642 24.9821 197.008 24.2757 197.008 23.3819C197.008 22.4882 197.642 21.7962 198.522 21.7962C199.416 21.7962 200.05 22.4882 200.05 23.3819C200.05 24.2757 199.416 24.9821 198.522 24.9821Z",
    fill: "#F7F7F5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7235_20320",
    x: 0.0778987,
    y: 0,
    width: 251.387,
    height: 66.4382,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.9221
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.961051
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7235_20320"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7235_20320",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_7235_20320",
    x: 27.4763,
    y: 27.7031,
    width: 30.729,
    height: 22.352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.9221
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.961051
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7235_20320"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7235_20320",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_7235_20320",
    x: 193.338,
    y: 27.7031,
    width: 30.729,
    height: 22.352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.9221
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.961051
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7235_20320"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7235_20320",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_7235_20320",
    x: 15.9861,
    y: 0,
    width: 221.852,
    height: 44.3755,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.9221
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.961051
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7235_20320"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7235_20320",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratulations);
export default __webpack_public_path__ + "static/media/congratulations.b51122b08c372babdbf1f5c2e5e129fe.svg";
export { ForwardRef as ReactComponent };